import { Component, type ReactNode } from 'react';
import { Alert, Button, Stack } from '@mantine/core';
import * as Sentry from '@sentry/react';

interface Props {
  children: ReactNode;
  label: string;
}

interface State {
  error: Error | null;
}

/** Route-level, so a broken timeline query does not blank the shell. */
export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error) {
    Sentry.captureException(error);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <Stack p="md">
        <Alert color="red" title={`${this.props.label} failed to render`}>
          {this.state.error.message}
        </Alert>
        <Button variant="light" onClick={() => this.setState({ error: null })}>
          Try again
        </Button>
      </Stack>
    );
  }
}
